const WORDS = ["Confiance", "Discipline", "Cap", "Résilience", "Respect", "Dépassement", "Mental d'acier", "Focus"];

const Marquee = () => (
  <div className="border-y border-white/5 bg-coal py-5 overflow-hidden" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {WORDS.map((w, i) => (
            <span key={`${copy}-${w}`} className="flex items-center">
              <span className="font-heading text-2xl sm:text-3xl font-extrabold uppercase tracking-wider text-slate-500 px-6">
                {w}
              </span>
              <span className={`text-lg ${i % 2 === 0 ? "text-ember" : "text-gold"}`}>✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
